import i18next from "i18next";
import { lazy } from "react";

import { getHiddenRoute } from "util/react";

import EN from "./i18n/en.json";

i18next.addResourceBundle("en", "RodsArticle", EN);

export const URIS = {
  LIST: "/rods-article",
  EDIT: "/rods-article/:id",
  NEW: "/rods-article/new",
};

export const RodsArticleListRoute = getHiddenRoute(
  "RodsArticle",
  "menu.main",
  URIS.LIST,
  lazy(() => import("./layout/RodsArticleListLayout")),
  null,
  ["admin"],
);
export const RodsArticleCreateRoute = getHiddenRoute(
  "RodsArticle",
  "menu.main",
  URIS.NEW,
  lazy(() => import("./layout/RodsArticleEditLayout")),
  null,
  ["admin"],
);
export const RodsArticleEditRoute = getHiddenRoute(
  "RodsArticle",
  "menu.main",
  URIS.EDIT,
  lazy(() => import("./layout/RodsArticleEditLayout")),
  null,
  ["admin"],
);

const RodsArticleRoute = (
  <>
    {RodsArticleListRoute}
    {RodsArticleCreateRoute}
    {RodsArticleEditRoute}
  </>
);

export default RodsArticleRoute;
